import * as React from 'react';

import {NumberedList} from 'shells/bulleted-list/numbered-list';
import {colors} from 'shells/colors/colors';
import {Illustration} from 'shells/illustrations/illustration';
import {Modal} from 'shells/modal/modal';
import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';
import {OnboardingPage} from 'shells/onboarding-page/onboarding-page';
import {ModalBody} from 'shells/typography/modal-body';

import {SwoopArrow} from '../../onboarding/lifting-of-the-curtain/slide-team/swoop-arrow';

type Props = {
    onClose: () => void;
};

function ImageWrapper({image}: {image: React.ReactNode}) {
    return (
        <div className='full-width full-height pad-64 border-box align-center justify-center flex'>
            {image}
        </div>
    );
}

export function ImportUnsubscribesOnboardingModal(props: Props) {
    return (
        <Modal
            isOpen={true}
            onClose={props.onClose}
            noPadding={true}
            closeButton={false}
            trapFocus={true}
            maxHeight={500}
        >
            <OnboardingPage
                type='singlePage'
                bodyId='importUnsubscribes'
                bodyComponent={<ImportUnsubscribesOnboardingBody />}
                artBackgroundColor={colors.plumLt}
                artImage={<ImageWrapper image={<Illustration src='unsubscribe-doodle' />} />}
                buttonText='Got it'
                onClose={props.onClose}
            />
            <div id='arrow-start'></div>
            {/* @ts-expect-error */}
            <SwoopArrow startSelector='arrow-start' destinationSelector='edit-button' />
        </Modal>
    );
}

function ImportUnsubscribesOnboardingBody() {
    return (
        <OnboardingBody title='Update unsubscribe statuses for people'>
            <div>
                <p>
                    You can update your people’s unsubscribe statuses right from the list view!
                    Individually select people, filter by specific criteria, or use one of your
                    saved lists.
                </p>
                <NumberedList
                    size='normal'
                    items={[
                        <ModalBody key='1'>Select some people</ModalBody>,
                        <ModalBody key='2'>
                            Click <span style={{fontWeight: 'bold'}}>Edit</span>
                        </ModalBody>,
                        <ModalBody key='3'>
                            Select the <span style={{fontWeight: 'bold'}}>Unsubscribe</span>{' '}
                            checkbox
                        </ModalBody>,
                    ]}
                />
                <p>
                    Apply your changes to update their unsubscribe statuses and ensure that they
                    won’t get any future outreach.
                </p>
                <p>This cannot be undone, so tread carefully!</p>
            </div>
        </OnboardingBody>
    );
}
